// extracted by mini-css-extract-plugin
export default {"faqs":"bu-z","faqContent":"cu-z","faq":"du-z"};